





















































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositBankSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/Banking/AccountDepositBankSettingsRead.vue';
import AccountDepositCardSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/Cards/AccountDepositCardSettingsRead.vue';
import AccountGeneralPayeeSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/GeneralPayee/AccountGeneralPayeeSettingsRead.vue';
import AccountDepositPaymentOrderSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/PaymentOrders/AccountDepositPaymentOrderSettingsRead.vue';
import AccountDepositInterestSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/DepositInterest/AccountDepositInterestSettingsRead.vue';
import AccountDepositInstantAccessSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/InstantAccess/AccountDepositInstantAccessSettingsRead.vue';
import AccountDepositFixedTermSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/FixedTerm/AccountDepositFixedTermSettingsRead.vue';
import AccountDepositFixedTermMaturitySettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/FixedTermMaturity/AccountDepositFixedTermMaturitySettingsRead.vue';
import AccountDepositOverdraftSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/Overdraft/AccountDepositOverdraftSettingsRead.vue';
import AccountDepositOverdraftInterestSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/OverdraftInterest/AccountDepositOverdraftInterestSettingsRead.vue';
import AccountDepositCoolingOffSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/CoolingOff/AccountDepositCoolingOffSettingsRead.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'DefaultWalletSettings', components: {
    AccountDepositBankSettingsRead,
    AccountDepositCardSettingsRead,
    AccountDepositPaymentOrderSettingsRead,
    AccountGeneralPayeeSettingsRead,
    AccountDepositInterestSettingsRead,
    AccountDepositInstantAccessSettingsRead,
    AccountDepositFixedTermSettingsRead,
    AccountDepositFixedTermMaturitySettingsRead,
    AccountDepositOverdraftSettingsRead,
    AccountDepositOverdraftInterestSettingsRead,
    AccountDepositCoolingOffSettingsRead
} })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    @Prop({required: true})
    accountId: string;

    tabIndex = 0;

    async beforeMount() {
        //TODO Move this back here when account settings are coming through from UX
        //This has been moved to the account details page for now so that we have enough product information to show on the DETAILS tab.
        //await DepositAccountSettingsModule.getAccount(this.accountId);
        //await DepositAccountSettingsModule.getProductIssue();
        await DepositAccountSettingsModule.getRateSources();
    }

    get hasSettingsEnabled() {
        // Checking if at least one of the settings groups are enabled is a bit more complicated because some of the settings are still
        // behind a feature toggle so the clearest way seems to be just one big conditon, one line below for each of the settings groups
        if ((this.visibility.depositBankSettings && this.settings.depositBankSettings  && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductBankSettings)) ||
        (this.visibility.depositCardSettings && this.settings.depositCardSettings  && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductCardSettings)) ||
        (this.visibility.depositCardSettings && this.settings.depositCardSettings  && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductCardSettings)) ||
        (this.visibility.depositPaymentOrderSettings && this.settings.depositPaymentOrderSettings) ||
        (this.visibility.depositInterestSettings && this.settings.depositInterestSettings) ||
        (this.visibility.depositInstantAccessSettings && this.settings.depositInstantAccessSettings) ||
        (this.visibility.depositOverdraftSettings && this.settings.depositOverdraftSettings) ||
        (this.visibility.depositOverdraftInterestSettings && this.settings.depositOverdraftInterestSettings) ||
        (this.visibility.depositFixedTermSettings && this.settings.depositFixedTermSettings) ||
        (this.visibility.depositFixedTermMaturitySettings && this.settings.depositFixedTermMaturitySettings) ||
        (this.visibility.depositCoolingOffSettings && this.settings.depositCoolingOffSettings)) {
            return true;
        }
        else {
            return false;
        }
    }

    get settings() {
        return DepositAccountSettingsModule.settings;
    }

    get visibility() {
        return DepositAccountSettingsModule.productFeatureVisibility;
    }

    get showZeroInterestWarning() {
        if (this.visibility.depositOverdraftSettings && this.settings.depositOverdraftSettings.enabled) {
            if (!this.settings.depositOverdraftInterestSettings ||
                !this.settings.depositOverdraftInterestSettings.enabled ||
                this.settings.depositOverdraftInterestSettings.cumulativeRateValue === 0)
            {
                return true;
            }
        }
        else {
            return false;
        }
    }
}
